module.exports = __webpack_public_path__ + "img/ImageGalleryWithLargePreview.914cb065.png";